interface ResponseUseLocalStorage {
  getItem: <T>(key: string) => T | null
  setItem: <T>(key: string, value: T) => void
  clear: () => void
  removeItem: (key: string) => void
}

export default function useLocalStorage(): ResponseUseLocalStorage {
  const getItem = <T>(key: string): T | null => {
    if (typeof window === 'undefined') {
      return null
    }
    const item = localStorage.getItem(key)
    return item ? (JSON.parse(item) as T) : null
  }

  const setItem = <T>(key: string, value: T): void => {
    if (typeof window === 'undefined') {
      return
    }
    if (value === undefined || value === null) {
      return
    }
    localStorage.setItem(key, JSON.stringify(value))
  }

  const clear = (): void => {
    if (typeof window !== 'undefined') {
      localStorage.clear()
    }
  }

  const removeItem = (key: string): void => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(key)
    }
  }

  return {
    getItem,
    setItem,
    clear,
    removeItem
  }
}
